// Standalone app identity constants.
//
// These are imported directly by nuxt.config.ts. Keeping them out of the
// barrel (./index.ts) means loading the config does not pull the whole
// constants tree through jiti, where Nuxt aliases like #shared do not exist.
export const appName = 'Avow'
export const appDescription = 'Put your deductible to work. Earn vault yield, document your property, and get adjuster review before you file.'
